/**
 * get the entries data.
 */
export function getEntriesData() {
	const tableContainer = document.querySelector( '.m__dashboard-table' );
	if ( !tableContainer ) {
		return;
	}

	const $tableContainer = $( tableContainer );
	const $tableBodyContainer = $tableContainer.find( '.m__dashboard-table-body' );
	const $nextButton = $( '.m__dashboard-table-pagination-next' );
	const $prevButton = $( '.m__dashboard-table-pagination-prev' );
	const $loader = $( '.m__dashboard-table .loader' );
	const dataType = $tableBodyContainer.data( 'datatype' );
	const offset = 6;
	let actualOffset = 0;
	let filterby = '';
	let filtertext = '';
	let userid = '';

	/**
	 * get the entries data.
	 *
	 * @param {int} offset the data offset value.
	 * @param {string} filterby the entries data is filter by this value.
	 * @param {string} filtertext the entries data is filter by this text.
	 * @param {string} userid An user ID (Optional, used for supervisor view).
	 * @return {string} the API URL with the given offset.
	 */
	function createApiUrl( offset = 0, filterby = '', filtertext = '', userid = '' ) {
		window.mce = 'mce' in window ? window.mce : {};
		return `${window.mce.api_url}
			ime-entry?datatype=${dataType}
			&offset=${offset}
			&filterby=${filterby}
			&filtertext=${filtertext}
			&userid=${userid}`;
	}

	/**
	 * Fetches the entries.
	 *
	 * @param {int} offset the data offset value.
	 * @param {string} filterby filter by ime status, date or tag.
	 * @param {string} filtertext filter value text.
	 * @param {int} userid A user ID.
	 */
	function fetchData( offset, filterby, filtertext, userid ) {
		$loader.show();
		$tableBodyContainer.html( '' );
		hidePagination();
		$.ajax({
			url: createApiUrl( offset, filterby, filtertext, userid ),
			dataType: 'json',
			success: function( response ) {
				renderResults( offset, response );
			},
			error: function() {
				renderError();
			},
		});
	}

	/**
	 * Renders the error html of ajax response.
	 */
	function renderError() {
		$loader.hide();
		$tableBodyContainer.html( '<div class="no-results">Error fetching data.</div>' );
		$tableContainer.trigger( 'clearSelectedEntries' );
	}

	/**
	 * Adds the fetched results to the table.
	 *
	 * @param {int} offset the data offset value.
	 * @param {array} response the ajax response.
	 */
	function renderResults( offset, response ) {
		$loader.hide();
		const data = response.data.length
			? response.data : '<div class="no-results">No Results</div>';
		$tableBodyContainer.html( data );
		const totalCount = parseInt( response.total_count, 10 );
		showNextButton( offset, totalCount );
		showPreviousButton( offset, totalCount );
		$tableContainer.trigger( 'clearSelectedEntries' );
	}

	/**
	 * Shows the Nex button checking if there is more data.
	 *
	 * @param {int} thisOffset the data offset value.
	 * @param {int} totalCount the total of data.
	 */
	function showNextButton( thisOffset, totalCount ) {
		const nextOffset = thisOffset + offset;
		if ( nextOffset < totalCount ) {
			$nextButton.addClass( 'active' );
		}
	}

	/**
	 * Shows the Nex button checking if there is more data.
	 *
	 * @param {int} thisOffset the data offset value.
	 * @param {int} totalCount the data total count.
	 *
	 * params 1st case: 0, 13 -> 0-6=-6 -> -6>=0 don't show button
	 * params 2nd case: 6, 13 -> 6-6=0 -> 0>=0 don't show button
	 * params 3rd case: 12, 13 -> 12-6=6 -> 6>=0 show button
	*/
	function showPreviousButton( thisOffset, totalCount ) {
		const previousOffset = thisOffset - offset;
		if ( previousOffset >= 0 && totalCount !== 0 ) {
			$prevButton.addClass( 'active' );
		}
	}

	/**
	 * Hide the pagination buttons.
	 */
	function hidePagination() {
		$nextButton.removeClass( 'active' );
		$prevButton.removeClass( 'active' );
	}

	/**
	 * Init.
	 */
	( function main() {
		fetchData( actualOffset );

		$nextButton.on( 'click', () => {
			actualOffset += offset;
			fetchData( actualOffset, filterby, filtertext, userid );
		});

		$prevButton.on( 'click', () => {
			actualOffset -= offset;
			fetchData( actualOffset, filterby, filtertext, userid );
		});

		$tableContainer.on( 'tableUpdate', function updateTable( event, data ) {
			actualOffset = 0;
			const defaultData = {
				offset: 0,
				filterby: '',
				filtertext: '',
				userid: '',
			};
			const finalData = Object.assign({}, defaultData, data );
			filterby = finalData.filterby;
			filtertext = finalData.filtertext;
			userid = finalData.userid;
			fetchData( finalData.offset, filterby, filtertext, userid );
		});
	})();
}
